<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#D4D7DE] bg-opacity-75 transition-opacity backdrop-blur-sm"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class=" fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <div class="w-screen max-w-3xl px-4 py-2 bg-white h-screen overflow-scroll">
                    <!-- Modal Content -->
                    <div>
                        <form [formGroup]="vehicleVarificationForm" (ngSubmit)="onsave()" class="mt-4">
                           
                            <div class="flex justify-between">
                                <div>
                                    <h2 class="heading">
                                        Vehicle Details
                                    </h2>
                                    <p class="text-sm-light">
                                        (Read Only)
                                    </p>
                                </div>

                                <div>
                                    <button type="button" (click)="onCloseModal()"
                                        class="rounded-lg p-1 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                                        <span class="sr-only">Close panel</span>
                                        <!-- Heroicon name: outline/x-mark -->
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>

                            </div>
                            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

                            <section class="grid gap-4 grid-cols-2">
                                <!-- description -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Description
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="description" type="text" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- vin -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        VIN
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="vin" type="text" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- licensePlateNumber -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        License Plate Number
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="licensePlateNumber" type="text" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- year -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Year
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="year" type="text" value="2024" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- make -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Make
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="make" type="text" value="2019" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- model -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Model
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="model" type="text" value="2019" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- color -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Color
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="color" type="text" value="White" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- spaceTypes -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Vehicle Type
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="spaceType" type="text" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <ng-container formGroupName="garageAddress">
                                    <!-- garageAddress name -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            Garaged Street Address
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input formControlName="name" type="text" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                    type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path
                                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                    </svg>
                                                </button>
                                                <button class="btn btn-success px-2" type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path fill-rule="evenodd"
                                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                            clip-rule="evenodd" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- garageAddress City -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            City
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input formControlName="city" type="text" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                    type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path
                                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                    </svg>
                                                </button>
                                                <button class="btn btn-success px-2" type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path fill-rule="evenodd"
                                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                            clip-rule="evenodd" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- garageAddress State -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            State
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input formControlName="state" type="text" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                    type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path
                                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                    </svg>
                                                </button>
                                                <button class="btn btn-success px-2" type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path fill-rule="evenodd"
                                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                            clip-rule="evenodd" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- serviceAreas -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Counties Served
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="serviceAreas" type="text" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </section>

                            <div class="mt-4">
                                <h2 class="heading">
                                    General Information
                                </h2>
                                <p class="text-sm-light">
                                    Please provide the following information and documents
                                </p>
                            </div>

                            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="grid grid-cols-2 gap-4">
                                <!-- Registration images -->
                                <div class="space-y-1" formGroupName="images">
                                    <label class="subheading">
                                        Registration
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">

                                            <a [href]="vehicleVarificationForm.get('images.registration')?.value"
                                                target="_blank" download="registration_image">
                                                <input class="read-only:cursor-pointer" formControlName="registration" type="text"
                                                    readonly />
                                            </a>
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Registration Expiration Date -->
                                <div class="space-y-1" formGroupName="dates">
                                    <label class="subheading">
                                        Registration Expiration Date
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="registration" readonly type="text" />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Inspection Report images -->
                                <div class="space-y-1" formGroupName="images">
                                    <label class="subheading">
                                        Inspection Report
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">

                                            <a [href]="vehicleVarificationForm.get('images.inspectionReport')?.value"
                                                target="_blank" download="inspectionReport_image">
                                                <input class="read-only:cursor-pointer" formControlName="inspectionReport"
                                                    type="text" readonly />
                                            </a>
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Inspection Report Completion Date -->
                                <div class="space-y-1" formGroupName="dates">
                                    <label class="subheading">
                                        Inspection Report Completion Date
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="inspectionReport"  readonly type="text" />
                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                               
                                  <!-- Vehicle Picture -->
                                <div class="space-y-1" formGroupName="images">
                                   
                                    <label class="subheading">
                                        Vehicle Picture
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <a [href]="vehicleVarificationForm.get('images.vehicle')?.value"
                                                target="_blank" download="inspectionReport_image" class="">
                                                <input class="read-only:cursor-pointer" formControlName="vehicle" type="text"
                                                    readonly />
                                            </a>

                                        </div>
                                        <div class="flex gap-1">
                                            <button class="btn-outline btn-outline-danger opacity-50 px-2"
                                                type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-success px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path fill-rule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </section>


                            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                                <div class="space-y-1 col-span-full">
                                    <label class="subheading">
                                        Following information are invalid and need to be resubmitted by the company.
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <button class="btn btn-primary">
                                            Send Information via Email
                                        </button>
                                    </div>
                                </div>
                            </section>

                            <div class="mt-4">
                                <h2 class="subheading">
                                    I have checked the information given and i hereby confirm that all data entered is
                                    valid and
                                    satisfactory for the purpose of compliance and billing of trip
                                </h2>
                            </div>

                            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Date
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="date" />
                                        </div>
                                    </div>
                                </div>
                                <div class="space-y-1">
                                    <label class="subheading">
                                        User
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <select name="" id="">
                                                <option value="">-- Select User --</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="flex justify-end gap-4">
                                <button type="submit" class="btn-outline btn-outline-secondary">
                                    Approve
                                </button>
                                <button class="btn btn-secondary">
                                    Send Contract
                                </button>
                            </section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>